import { render, staticRenderFns } from "./AssignmentFilters.vue?vue&type=template&id=d53b0008&scoped=true"
import script from "./AssignmentFilters.vue?vue&type=script&lang=js"
export * from "./AssignmentFilters.vue?vue&type=script&lang=js"
import style0 from "./AssignmentFilters.vue?vue&type=style&index=0&id=d53b0008&prod&lang=css"
import style1 from "./AssignmentFilters.vue?vue&type=style&index=1&id=d53b0008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53b0008",
  null
  
)

export default component.exports